import React, { useState, useContext } from "react";
import AccordionItem from "../AccordionItem/AccordionItem";
import useBuildTree from "../../Hooks/useBuildTree.js";
import uuid from "react-native-uuid";
import TreeItem from "../TreeItem/TreeItem";
import "./AccordionList.css";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import FormSettings from "../Settings/FormSettings/FormSettings";
import SettingsStep from "../Settings/Information/SettingsStep";
import { store } from "../../store.js";


export default function AccordionList(props) {
  const globalState = useContext(store);
  const buildTree = useBuildTree();
  const { dispatch } = globalState;

  const firstStep = props.accordionsItems.data.filter(item => item.order == 1)[0]
  var step = firstStep && { ...firstStep.items.data[0], conditionDescription:firstStep.conditionDescription}
  var TreeItem = [];
  var parentsNodes = [];
  if (step) buildTree(TreeItem, props.accordionsItems.data, step, null, [], [], parentsNodes);

  const [accordionsItems, setAccordionsItems] = useState({
    data: props.accordionsItems.data,
    lists: props.accordionsItems.lists,
  });

  const [VisibleMenuDotIds, setVisibleMenuDotIds] = useState([]);
  const [expandeds, setExpandeds] = useState([]);

  const onChangeConditionDescription = (value,menu) => {
    var updatedData = JSON.parse(JSON.stringify(props.accordionsItems.data));

    updatedData.filter(data => data.id == menu.id).forEach(item => {
      item.conditionDescription = value
    });
    dispatch({
      type: props.type,
      payload: { data: updatedData, lists: props.accordionsItems.lists },
    });
  };

  const onExpandCollapseClick = (e, isMenuExpanded, menu) => {
    if (isMenuExpanded) {
      deleteMenuIdFromExpandeds(menu);
    } else {
      addMenuIdToExpandeds(menu.id);
    }
  };

  const onMouseOver = (e, menuId) => {
    if (!VisibleMenuDotIds.includes(menuId)) {
      setVisibleMenuDotIds([menuId]);
    }
  };

  const getNestedNode = (menu, arrayNode) => {
    if (menu.childs.length == 0) arrayNode.push(menu.id);
    menu.childs.map((item) => {
      arrayNode.push(menu.id);
      return getNestedNode(item, arrayNode);
    });
  };


  const addMenuIdToExpandeds = (id) => {
    setExpandeds([...expandeds, id]);
  };

  const deleteMenuIdFromExpandeds = (menu) => {
    var arrayNodes = [];
    getNestedNode(menu, arrayNodes);
    var newExpandeds = expandeds.filter((item) => !arrayNodes.includes(item));
    setExpandeds(newExpandeds);
  };

  const isMenuExpanded = (idMenu) => {
    return expandeds.includes(idMenu);
  };

  const isMenuVisible = (idMenu) => {
    var isMenuVisible = VisibleMenuDotIds.includes(idMenu);

    return isMenuVisible;
  };

  const removeFirstOccurence = (src, value) => {
    var index = src.indexOf(value);
    if (index == -1) return src;
    else return [...src.slice(0, index), ...src.slice(index + 1)];
  };

  const onDropDownItemClick = (itemSelected, currentItem) => {
    var updatedData = JSON.parse(JSON.stringify(props.accordionsItems.data));

    updatedData.map((menuItem) => {
      getUpdatedLists(menuItem, itemSelected, currentItem);
    });
    
    dispatch({
      type: props.type,
      payload: {
        data: updatedData,
        lists: props.accordionsItems.lists,
      },
    });
  };

  const onMenuItemClick = (menuItem, currentOrder, menuId, menuGlobalId, itemId) => {
    
    switch (menuItem.action.type) {
      case "SettingsParent":
        props.CallSettingsStep({menuId:menuId, menuGlobalId:menuGlobalId, currentOrder:currentOrder, itemId:itemId})
        break;
      case "AddNewParent":
        onClickAddNewParent(menuItem.template, currentOrder);
        break;
      case "AddUnderParent":
        onClickAddUnderParent(menuItem.template, currentOrder);
        break;
      case "AddChild":
        onClickAddDecision(menuItem.template, currentOrder);
        break;
      case "DeleteParent":
        onClickDeleteParent(menuItem.template, currentOrder);
        break;
      case "CascadeDeleteParent":
        onClickCascadeDeleteParent(menuItem.template, currentOrder);
        break;
      case "DeleteChild":
        onClickDeleteDecision(menuItem.template, currentOrder, menuId);
        break;
    }
  };

  const onClickAddNewParent = (menuItem, currentOrder) => {
    var maxId = props.accordionsItems.lists.currentMaxId;
    var firstOneSteps = props.accordionsItems.data.slice(0, currentOrder);
    var lastSteps = props.accordionsItems.data.slice(
      currentOrder,
      props.accordionsItems.data.length
    );
    lastSteps.map((item) => (item.order = item.order + 1));

    var nextItem = JSON.parse(JSON.stringify(menuItem));

    nextItem.globalId = uuid.v4();
    nextItem.id = maxId + 1;
    nextItem.order = currentOrder + 1;
    nextItem.items.data[0].id = maxId + 2;
    nextItem.items.data[0].globalId = uuid.v4();
    var updatedLists = props.accordionsItems.lists;
    updatedLists.currentMaxId = maxId + 2;
    var updatedData = [...firstOneSteps, nextItem, ...lastSteps];

    dispatch({
      type: props.type,
      payload: { data: updatedData, lists: updatedLists },
    });
  };

  const onClickAddUnderParent = (menuItem, currentOrder) => {
    var maxId = props.accordionsItems.lists.currentMaxId;

    var updatedData = JSON.parse(JSON.stringify(props.accordionsItems.data));

    var childItem = JSON.parse(JSON.stringify(menuItem.decision));
    var nextItem = JSON.parse(JSON.stringify(menuItem.step));
    var childOrder = parseInt(
      updatedData
        .filter((item) => item.order == currentOrder)
        .map((item) => item.childs.length)
    );
    childItem.id = maxId + 1;
    childItem.globalId = uuid.v4();
    childItem.items.data[0].id = maxId + 2;
    childItem.items.data[0].globalId = uuid.v4();
    childItem.order = childOrder + 1;
    updatedData
      .filter((item) => item.order == currentOrder)
      .map((item) => item.childs.push(childItem));

    var firstOneSteps = updatedData.slice(0, currentOrder);
    var lastSteps = updatedData.slice(currentOrder, updatedData.length);
    lastSteps.map((item) => (item.order = item.order + 1));
    nextItem.id = maxId + 3;
    nextItem.globalId = uuid.v4();
    nextItem.items.data[0].id = maxId + 4;
    nextItem.items.data[0].globalId = uuid.v4();
    nextItem.order = currentOrder + 1;

    var updatedLists = props.accordionsItems.lists;
    updatedLists.currentMaxId = maxId + 4;
    var updatedData = [...firstOneSteps, nextItem, ...lastSteps];

    dispatch({
      type: props.type,
      payload: { data: updatedData, lists: updatedLists },
    });
  };

  const onClickAddDecision = (menuItem, currentOrder) => {
    var maxId = props.accordionsItems.lists.currentMaxId;

    var updatedData = JSON.parse(JSON.stringify(props.accordionsItems.data));

    var childItem = JSON.parse(JSON.stringify(menuItem.decision));
    var nextItem = JSON.parse(JSON.stringify(menuItem.step));
    var childOrder = parseInt(
      updatedData
        .filter((item) => item.order == currentOrder)
        .map((item) => item.childs.length)
    );
    childItem.id = maxId + 1;
    childItem.globalId = uuid.v4();
    childItem.items.data[0].id = maxId + 2;
    childItem.items.data[1].id = maxId + 3;
    childItem.items.data[0].globalId = uuid.v4();
    childItem.items.data[1].globalId = uuid.v4();
    childItem.order = childOrder + 1;
    updatedData
      .filter((item) => item.order == currentOrder)
      .map((item) => item.childs.push(childItem));

    var firstOneSteps = updatedData.slice(0, currentOrder);
    var lastSteps = updatedData.slice(currentOrder, updatedData.length);
    lastSteps.map((item) => (item.order = item.order + 1));
    nextItem.id = maxId + 4;
    nextItem.globalId = uuid.v4();
    nextItem.items.data[0].id = maxId + 5;
    nextItem.order = currentOrder + 1;

    var updatedLists = props.accordionsItems.lists;
    updatedLists.currentMaxId = maxId + 5;
    var updatedData = [...firstOneSteps, nextItem, ...lastSteps];

    dispatch({
      type: props.type,
      payload: { data: updatedData, lists: updatedLists },
    });
  };

  const onClickDeleteDecision = (menuItem, currentOrder, menuId) => {
    var updatedData = JSON.parse(JSON.stringify(props.accordionsItems.data));

    var currentChild = updatedData
      .map((item) =>
        item.childs
          .filter((child) => child.id == menuId)
          .map((child) => child.id)
      )
      .filter((item) => item.length > 0)
      .flat(1);

    updatedData.map(
      (item) =>
        (item.childs = item.childs
          ? item.childs.filter((child) => !currentChild.includes(child.id))
          : [])
    );

    updatedData.map((item) =>
      item.childs.map((item, index) => (item.order = index + 1))
    );

    dispatch({
      type: props.type,
      payload: {
        data: updatedData,
        lists: props.accordionsItems.lists,
      },
    });
  };

  const onClickCascadeDeleteParent = (menuItem, currentOrder) => {
    var orders = [];
    getAllChildrensOrderNumber(currentOrder, orders);
    var updatedData = props.accordionsItems.data.filter(
      (item) => !orders.includes(item.order)
    );
    updatedData.map((item, index) => (item.order = index + 1));

    dispatch({
      type: props.type,
      payload: {
        data: updatedData,
        lists: props.accordionsItems.lists,
      },
    });
  };

  const onClickDeleteParent = (menuItem, currentOrder) => {
    var updatedData = JSON.parse(JSON.stringify(props.accordionsItems.data));

    var updatedData = updatedData.filter((item) => currentOrder != item.order);
    updatedData.map((item, index) => (item.order = index + 1));

    dispatch({
      type: props.type,
      payload: {
        data: updatedData,
        lists: props.accordionsItems.lists,
      },
    });
  };

  const getAllChildrensOrderNumber = (currentOrder, ids) => {
    var childs = props.accordionsItems.data
      .filter((item) => item.order == currentOrder)
      .map((item) => item.childs)
      .flat(1)
      .map((item) => item.items.data.map((item) => item))
      .flat(1)
      .filter((item) => item.list == "Steps")
      .map((item) => item.item.id);

    ids.push(currentOrder);

    var nextItem = props.accordionsItems.data.filter((item) =>
      childs.includes(item.items.data[0].item.id)
    );

    if (nextItem.length == 0)
      nextItem = props.accordionsItems.data.filter(
        (item) => item.order == currentOrder + 1
      );

    nextItem.map(
      (item) =>
        !ids.includes(item.order) && getAllChildrensOrderNumber(item.order, ids)
    );
    return ids;
  };

  const getUpdatedLists = (menuItem, itemSelected, currentItem) => {
    
    if (menuItem.item && menuItem.id == currentItem.id) {
      menuItem.item = itemSelected;
      
      return;
    } else if (
      !menuItem.items &&
      (!menuItem.childs || (menuItem.childs && menuItem.childs.length == 0))
    ) {
      
      return;
    }
    menuItem.items.data.map((item) => {
      getUpdatedLists(item, itemSelected, currentItem);
    });
    menuItem.childs.map((item) => {
      getUpdatedLists(item, itemSelected, currentItem);
    });
  };

  const isNodeWithCondition  = (node) => {
    
    return props.withCondition && isNodeHasChildCondition(node)
  }

  const isNodeHasChildCondition  = (node) => {
 
    return node.childs.filter(child => child.items.data.filter(item => item.list == "Decisions").length > 0).length > 1
  }

  const isInTree = (parentNodeId) => {
    
    return parentsNodes.includes(parentNodeId)
  };

  const showMenu = (menu, lists, parentItem) => {
    if (menu == "") return;
    var isMenuHasChilds = menu.childs.length > 0;
    var menuExpanded = isMenuHasChilds && isMenuExpanded(menu.id);
    
    const currentItemId = menu.items.data[0].item.globalId
    return (
      <li
        key={menu.id}
        name={menu.id}
        className={menuExpanded ? "liOpenAccordion" : "liAccordion"}
      >
        <AccordionItem
          lists={lists}
          menuList={lists[menu.menu]}
          items={menu.items}
          isMenuHasChilds={isMenuHasChilds}
          isNodeWithCondition = {isNodeWithCondition(menu)}
          conditionDescription = {menu.conditionDescription}
          isInTree = {isInTree(parentItem.id)}
          onChangeConditionDescription={(value) =>
            onChangeConditionDescription(value, menu)
          }
          onExpandCollapseClick={(e) =>
            onExpandCollapseClick(e, menuExpanded, menu)
          }
          isExpanded={menuExpanded}
          isMenuVisible={isMenuVisible(menu.id)}
          onDropDownItemClick={(itemSelected, currentItem) =>
            onDropDownItemClick(itemSelected, currentItem)
          }
          onMenuItemClick={(menuItem) =>
            onMenuItemClick(menuItem, menu.order, menu.id, menu.globalId, currentItemId)
          }
          onMouseOver={(e) => onMouseOver(e, parseInt(menu.id))}
        />
        
        {isMenuHasChilds && (
          <div
            style={{
              visibility: menuExpanded ? "collapse" : "visible",
            }}
          >
            <ul className="ulAccordion" key={menu.id}>
              {menu.childs.map((item) => showMenu(item, lists, parentItem))}
            </ul>
          </div>
        )}
      </li>
    );
  };
 
  return props.accordionsItems.data.map((item) => (
    <ul className="ulbaseAccordion" key={"ul" + item.id}>
      {showMenu(item, props.accordionsItems.lists, item)}
      
    </ul>
  ));
}
